<template>
  <div>
    <ul class="v-breadcrumbs theme--dark pl-3 py-3">
      <template v-for="(item,key) in items" >
        <li :key="item.text" v-if="key !== 0" class="v-breadcrumbs__divider">></li>
        <li :key="key">
          <router-link class="v-breadcrumbs__item" :to="{ path: item.href }">{{ item.text }}</router-link>
        </li>
      </template>
    </ul>
    <v-breadcrumbs v-if="1== 0" :items="items" divider="/" :class="layoutClass" />
  </div>
</template>

<script>

export default {
  name: 'Breadcrumb',
  props: ['layoutClass'],
  computed: {

    items() {

      const { params, matched } = this.$route;
      const items = [
        {
          text: this.$t('global.home'),
          href: '/'
        }
      ];
    //  const lastItem = matched[matched.length - 1];
      for (let i = 0, len = matched.length; i < len; i += 1) {
        const route = matched[i];

        if (route.path) {
          var href = route.path;
          var nameRoute = route.name;
          if (route.meta) {
            if (route.meta.breadcrumb) nameRoute = this.$t(route.meta.breadcrumb);
          }

          for (const property in params) {
            const value = encodeURIComponent(params[property]);
            href = href.replace(`:${property}`, value);

          }

          // Ajoute la route show pour les route update
          if (route.path.includes(':id/edit')) {
            var hrefShow = href.replace(`/edit`, '');
            items.push({
              text: nameRoute,
              href: hrefShow
            });
            nameRoute = this.$t('global.update');
          }

          items.push({
            text: nameRoute,
          //  disabled: route.path === path || lastItem.path === route.path,
            href: href
          });

        }
      }

      return items;
    }
  }
};
</script>
